import moment from 'moment';

export const applyFiler = ({
  id,
  setDateFilter,
  startAddInvoices,
  setIsMenuOpen,
  startDate,
  toDate,
  setDateRange,
  handleCloseDatePicker,
  isDatePickerOpen,
  billToSiteNumber,
}) => {
  let filter;

  switch (id) {
    case 'last-month':
      if (isDatePickerOpen) {
        handleCloseDatePicker();
      }
      filter = {
        startDate: moment()
          .subtract(1, 'month')
          .format('YYYY-MM-DD'),
        toDate: moment().format('YYYY-MM-DD'),
        billToSiteNumber,
      };
      setDateFilter(filter);
      startAddInvoices(filter).then(() => {
        setDateRange({
          from: moment().subtract(1, 'month'),
          to: moment(),
        });
        setIsMenuOpen(false);
      });
      return true;
    case 'current-month':
      if (isDatePickerOpen) {
        handleCloseDatePicker();
      }
      filter = {
        startDate: moment()
          .startOf('month')
          .format('YYYY-MM-DD'),
        toDate: moment().format('YYYY-MM-DD'),
        billToSiteNumber,
      };
      setDateFilter(filter);
      startAddInvoices(filter).then(() => {
        setDateRange({
          from: moment().startOf('month'),
          to: moment(),
        });
        setIsMenuOpen(false);
      });
      return true;
    case 'previous-month':
      if (isDatePickerOpen) {
        handleCloseDatePicker();
      }
      filter = {
        startDate: moment()
          .startOf('month')
          .subtract(1, 'month')
          .format('YYYY-MM-DD'),
        toDate: moment()
          .subtract(1, 'month')
          .endOf('month')
          .format('YYYY-MM-DD'),
        billToSiteNumber,
      };
      setDateFilter(filter);
      startAddInvoices(filter).then(() => {
        setDateRange({
          from: moment()
            .startOf('month')
            .subtract(1, 'month'),
          to: moment()
            .subtract(1, 'month')
            .endOf('month'),
        });
        setIsMenuOpen(false);
      });
      return true;
    case 'last-three-months':
      if (isDatePickerOpen) {
        handleCloseDatePicker();
      }
      filter = {
        startDate: moment()
          .subtract(3, 'month')
          .format('YYYY-MM-DD'),
        toDate: moment().format('YYYY-MM-DD'),
        billToSiteNumber,
      };
      setDateFilter(filter);
      startAddInvoices(filter).then(() => {
        setDateRange({
          from: moment().subtract(3, 'month'),
          to: moment(),
        });
        setIsMenuOpen(false);
      });
      return true;
    default:
      if (
        moment(toDate, 'YYYY-MM-DD').diff(
          moment(startDate, 'YYYY-MM-DD'),
          'day'
        ) < 366
      ) {
        filter = {
          startDate,
          toDate,
          billToSiteNumber,
        };
        setDateFilter(filter);
        startAddInvoices(filter).then(() => {
          handleCloseDatePicker();
          setIsMenuOpen(false);
        });
        return true;
      } else {
        handleCloseDatePicker();
        setIsMenuOpen(false);
        return false;
      }
  }
};
